<template>
  <div class="salon-cars__box">
    <div class="salon-cars container car-view" :style="colorStyle" v-if="company">
      <div class="salon-cars__container container section-car-padding">
        <div class="head">
          <!--                <div class="salon-cars__brands" v-if="company.brands">-->
          <!--                    <ul class="salon-cars__brands-list">-->
          <!--                        <li class="salon-cars__brands-list-item"-->
          <!--                            v-for="(imageBrand,i) in company.brands" :key="i">-->
          <!--                            <img :src="getBrandLogo(imageBrand.brand)" alt="">-->
          <!--                        </li>-->
          <!--                    </ul>-->
          <!--                </div>-->
          <div class="salon-cars__big-image">
            <img v-if="company.big_image" :src="getCompanyImg(company.big_image)" alt="">
          </div>
        </div>
        <div class="body">
          <div class="salon-cars__content">
            <div class="salon-cars__content-logo" v-if="company.logo">
              <img :src="getCompanyImg(company.logo)" alt="">
            </div>
            <div class="salon-cars__content-wrap">
              <h3 class="salon-cars__content-title">{{ company.name }}</h3>
              <p class="salon-cars__content-description">{{ company.description }}</p>

              <router-link :to="goCompany" class="amount-cars-available__link">
                {{ company.total_cars.new_cars }} bílar á söluskrá
              </router-link>

              <router-link v-if="company.total_cars.stock_cars > 0 && $store.state.showCarsInStock" :to="goStockCompany"
                           class="amount-cars-available__link">
                {{ company.total_cars.stock_cars }} Kjarabílar
              </router-link>

              <!--            <ul :class="{'salon-cars__brands-blocks-list':company.id != 77,'salon-cars__brands-blocks-list-compamy77':company.id == 77}" v-if="company.brands">-->
              <ul class="salon-cars__brands-blocks-list" :class="{'company77':company.id == 77}">
                <li @click="go(imageBrand.brand_id)" class="salon-cars__brands-blocks-item"
                    v-for="(imageBrand,i) in company.brands"
                    :key="i">
                  <img :src="getBrandLogo(imageBrand)" alt="">
                  <!--                <span>{{ imageBrand.brand ? imageBrand.brand.capitalize() : '' }}</span>-->

                </li>
              </ul>
            </div>
          </div>
          <company-contacts v-if="company.active==1" :company="company"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CompanyContacts from "./CompanyContacts";
import globalNewCar from "../../helpers/globalNewCar";
import {mapState} from "vuex";

export default {
  components: {
    CompanyContacts
  },
  props: {
    company: {
      type: Object
    },
  },
  methods: {
    go(brand_id) {
      let pageUrl = "/nyir-bilar";
      // if (this.$route.path.search("kjarabilar") > 0) {
      //   pageUrl = '/kjarabilar';
      // }
      let url = pageUrl + globalNewCar.setUrlParams({brands: [brand_id]});
      this.$router.push(url);
    },
    getBrandLogo(brand) {
      let lib = this.$store.state.lib.brands
      let findB = lib && lib.find(e => e.id == brand.brand_id);
      return this.imageUrl + (findB && findB.logo ? findB.logo : null);
    },
    getCompanyImg(img) {
      return globalNewCar.getCompanyImg(img);
    }
  },
  computed: {
    ...mapState({
      imageUrl:(state)=>state.imageUrl
    }),
    goStockCompany() {
      let url = "/kjarabilar" + globalNewCar.setUrlParams({company: [this.company.id]});
      return url;
    },
    goCompany() {
      let url = "/nyir-bilar" + globalNewCar.setUrlParams({company: [this.company.id]});
      return url
    },
    colorStyle() {
      if (this.company.color) {
        let color = this.company.color;
        return `background: -webkit-gradient(linear, left top, left bottom, from(${color}), color-stop(40%, ${color}), color-stop(40%, #fff), to(#fff));`
      }
      return {};
    }
  }
}
</script>
